import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'connection-layout',
  templateUrl: './connection-layout.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterModule],
})
export class ConnectionLayoutComponent {}
